var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFuse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#B4F9BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1561 7.13234L15.7714 5.04455C15.8743 4.98515 16.002 4.98515 16.105 5.04455L25.6332 10.5457C25.7362 10.6051 25.7995 10.715 25.8004 10.8337L25.8134 14.6173C25.8134 14.7371 25.75 14.848 25.646 14.9073L22.0357 16.9922C21.8139 17.1209 21.5357 16.9605 21.5348 16.7041L21.5229 13.3086C21.5229 13.1898 21.4585 13.0799 21.3556 13.0205L12.1561 7.71047C11.9333 7.58177 11.9333 7.26104 12.1561 7.13234Z",
    fill: "#010101"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82138 24.2701L6.2071 22.1833C6.10315 22.1239 6.03979 22.014 6.03979 21.8943V10.892C6.03979 10.7732 6.10315 10.6633 6.20611 10.6029L9.47688 8.69928C9.58083 8.6389 9.70853 8.6389 9.81148 8.69928L13.4218 10.7841C13.6436 10.9128 13.6445 11.2325 13.4228 11.3622L10.4886 13.0699C10.3856 13.1293 10.3223 13.2392 10.3223 13.3589V23.982C10.3223 24.2394 10.0441 24.3989 9.82138 24.2701Z",
    fill: "#010101"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8133 17.7197V21.8933C25.8133 22.0131 25.7499 22.123 25.646 22.1823L16.1178 27.6835C16.0149 27.7429 15.8882 27.7429 15.7852 27.6835L12.5015 25.8026C12.3976 25.7432 12.3333 25.6323 12.3333 25.5125V21.3439C12.3333 21.0875 12.6104 20.9271 12.8332 21.0538L15.7792 22.7417C15.8822 22.8011 16.009 22.8001 16.1119 22.7417L25.3114 17.4297C25.5341 17.301 25.8123 17.4614 25.8123 17.7187L25.8133 17.7197Z",
    fill: "#010101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuse);
export default __webpack_public_path__ + "static/media/fuse.99fc2155365dab0914a9812ac3afc6b4.svg";
export { ForwardRef as ReactComponent };